'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction = require('is-function');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _validate2 = require('./validate.types');

var _validate3 = _interopRequireDefault(_validate2);

var _types = require('./types.types');

var _types2 = _interopRequireDefault(_types);

var _required2 = require('./required.types');

var _required3 = _interopRequireDefault(_required2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$type = _ref.type,
      type = _ref$type === undefined ? null : _ref$type,
      _ref$format = _ref.format,
      _format = _ref$format === undefined ? null : _ref$format,
      _ref$validate = _ref.validate,
      _validate = _ref$validate === undefined ? null : _ref$validate;

  if (!_types2.default.includes(type)) throw new Error('Invalid type \'' + type + '\'. Has to be one of: ' + _types2.default.join(', '));
  if (!(0, _isFunction2.default)(_format)) throw new Error('format argument has to be a function');
  if (!(0, _isFunction2.default)(_validate)) throw new Error('validate argument has to be a function');

  var fn = function fn() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      required: function required() {
        return _required3.default.apply(undefined, [type].concat(args));
      },
      format: function format() {
        return _format.apply(undefined, args);
      },
      validate: function validate() {
        return args.length > 0 && (0, _validate3.default)(type, args[0]) && _validate.apply(undefined, args);
      }
    };
  };

  fn.type = type;
  fn.format = _format;
  fn.validate = _validate;
  return fn;
};